import Application from 'pmt-modules/archi/Application'

import analytics from './config/analytics'
import appConfig from './config/appConfig'
import devMiddlewares from './config/devMiddlewares'
import dialogs from './config/dialogs'
import entities from './config/entities'
import environment from './config/environment'
import events from './config/events'
import forms from './config/forms'
import getApiManagerOptions from './config/getApiManagerOptions'
import i18n from './config/i18n'
import middlewares from './config/middlewares'
import routingEnum from './config/routingEnum'
import theme from './config/theme'

require('pmt-modules/archi/styles/fontLato.scss')

const appOptions = {
  analytics,
  appConfig,
  devMiddlewares,
  dialogs,
  entities,
  environment,
  events,
  forms,
  getApiManagerOptions,
  i18n,
  middlewares,
  routingEnum,
  theme,
}

Application(appOptions)
